import { AllowedDirectoryVideoTypesLabels } from '../types/programModulesAndContents';

export const allowedDirectoryVideoOptions = Object.entries(
  AllowedDirectoryVideoTypesLabels
).map(([key, label]) => ({
  value: key,
  label,
}));
